import Swiper from 'swiper'
export default {
    name: "banner",
    data () {
        return{
            data: {
                index: {
                    btnTxt: '开始使用',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 60px',
                    // align: 'right'
                    banner: [
                        { img: 'img/index/banner2.png', imgwap: 'img/index/wap/banner2.png', txt: '用数字科技<br/>连接私域流量与线下商业'},
                        { img: 'img/index/banner1.png', imgwap: 'img/index/wap/banner1.png', txt: '用数字科技<br/>连接私域流量与线下商业'},
                        { img: 'img/index/banner3.png', imgwap: 'img/index/wap/banner3.png', txt: '用数字科技<br/>连接私域流量与线下商业'},
                        { img: 'img/index/banner4.png', imgwap: 'img/index/wap/banner4.png', txt: '用数字科技<br/>连接私域流量与线下商业' },
                        { img: 'img/index/banner5.png', imgwap: 'img/index/wap/banner5.png', txt: '用数字科技<br/>连接私域流量与线下商业' }
                    ]
                },
                lianTuoCompany: {
                    txt: '我们认为每个线下门店<br/>都值得用数字化工具“重做”一次',
                    fontSize: 'font-size: 60px',
                    banner: [
                        { img: 'img/lianTuoCompany/banner1.png' },
                        { img: 'img/lianTuoCompany/banner2.png' },
                        { img: 'img/lianTuoCompany/banner3.png' }
                    ]
                },
                lianTuoRecruit: {
                    btnTxt: '火热招募中',
                    btnHref: '/lianTuoRecruitInfo',
                    btnType: 'router',
                    fontSize: 'font-size: 60px',
                    banner: 'img/lianTuoRecruit/banner.png',
                    txt: '在联拓工作<br/>不断创新 塑造未来'
                },
                lightMember: {
                    btnTxt: '开通轻会员',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/lightMember/banner.png',
                    txt: '“轻会员”<br/>再小的店也有做大的一天'
                },
                caseRetail: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseRetail/banner.png',
                    txt: '小精灵数字零售'
                },
                caseRestaurant: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseRestaurant/banner.png',
                    txt: '小精灵数字餐饮'
                },
                caseGas: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseGas/banner.png',
                    txt: '小精灵数字加油站'
                },
                caseAmusement: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseAmusement/banner.png',
                    txt: '小精灵数字泛娱乐'
                },
                caseCampus: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseCampus/banner.png',
                    txt: '小精灵数字校园'
                },
                caseHotel: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/caseHotel/banner.png',
                    txt: '小精灵数字酒店'
                },
                digitalizeApplets: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 60px',
                    banner: 'img/digitalizeApplets/banner.png',
                    txt: '<span class="span1">商家小程序<br/>门店增收的利器</span><span class="span2">真正实现用户支付和会员、线上和线下无缝连接的商户小程序，更好的帮助门店销售业绩增长。</span>'
                },
                digitalizeBackstage: {
                    btnTxt: '开始使用',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/digitalizeBackstage/banner.png',
                    txt: '小精灵商户管理后台<br/><span class="span2">您专属的数字化管理平台</span>'
                },
                payMerchant: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 60px',
                    banner: 'img/payMerchant/banner.png',
                    txt: '<span class="span1">持续为门店实现业绩增长</span><span class="span2">小精灵商户通APP是我们为商家量身打造的一款移动应用客户端。<br/>提供“支付+营销”一体化的智慧新零售移动工具。</span>'
                },
                paySoftware: {
                    btnTxt: '联系销售',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/paySoftware/banner.png',
                    txt: '小精灵【PRO版】软件'
                },
                payPos: {
                    btnTxt: '开始使用',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    banner: 'img/payPos/banner.png',
                    txt: '安全、快速、稳定<br/>打通你的ERP数据'
                },
                payElves: {
                    btnTxt: '开始使用',
                    btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    btnType: 'href',
                    fontSize: 'font-size: 70px',
                    txt: '是时候升级你的收银软件了',
                    adTxt: true
                }
            },
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/【收款小精灵】页面 头图  宣传视频（静音自动播放）.mov', // url地址
                        //src: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/【轻会员】视频.MP4', // url地址
                    },
                ],
                width: '100%',
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true, // 全屏按钮
                },
            },
            bannerIndex: 0,
            banner: '',
			bannerCss: '',
            bannerTxt: '',
			bannerTxtAlign: '',
			bannerTag: [
				{
					btnTxt:'零售',
					btnHref: '/digitalizeRetail',
					btnType: 'router',
				},
				{
					btnTxt:'餐饮',
					btnHref: '/digitalizeRestaurant',
					btnType: 'router',
				},
				{
					btnTxt:'加油站',
					btnHref: '/gasStation',
					btnType: 'router',
				},
				{
					btnTxt:'娱乐美业',
					btnHref: '/advancedMarketing',
					btnType: 'router',
				},
				{
					btnTxt:'商圈',
					btnHref: 'https://www.yuque.com/lt/jjfa/oe2lq1',
					btnType: 'href',
				},
			],
			bannerNum: 0,
            fontSize: '',
            btnTxt: '',
            btnHref: '',
            btnType: '',
            bannerState: false,
            adTxt: true
        }
    },
    computed:{
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        selectBanner(){
            let _this = this;
            let path = _this.$route.path;
            // eslint-disable-next-line no-unused-vars
            let bannerData = {};
            if(path === "/" || path === "/index") _this.bannerIndex = 0;
            if(path === "/lianTuoCompany") _this.bannerIndex = 1;
            if(path === "/lianTuoRecruit" || path === "/lightMember" || path === "/caseRetail" || path === "/caseRestaurant" || path === "/caseGas" || path === "/caseAmusement" || path === "/caseCampus" || path === "/caseHotel" || path === "/digitalizeApplets" || path === "/digitalizeBackstage" || path === "/payMerchant" || path === "/paySoftware" || path === "/payPos") _this.bannerIndex = 2;
            if(path === "/payElves"){
                _this.bannerIndex = 3;
            }
            if(_this.bannerIndex === 0){
                bannerData = _this.data['index'];
                // let bannerNum = Math.round(Math.random()*3);
				// console.log('_this.bannerNum',_this.bannerNum)
				let clientWidth = document.documentElement.clientWidth;
				if(clientWidth <= 1036){
					_this.banner = bannerData.banner[_this.bannerNum].imgwap;
				}else{
					_this.banner = bannerData.banner[_this.bannerNum].img;
				}
                _this.bannerTxt = bannerData.banner[_this.bannerNum].txt;
				_this.bannerTxtAlign = bannerData.banner[_this.bannerNum].align;
                _this.btnTxt = bannerData.btnTxt;
                _this.btnHref = bannerData.btnHref;
                _this.btnType = bannerData.btnType;
                _this.fontSize = bannerData.fontSize;
            }
            if(_this.bannerIndex === 1){
                bannerData = _this.data['lianTuoCompany'];
                _this.bannerTxt = bannerData.txt;
                _this.banner = bannerData.banner;
                _this.fontSize = bannerData.fontSize;
            }
            if(_this.bannerIndex === 2){
                let index = path.replace('/', '')
                bannerData = _this.data[index];
                _this.banner = bannerData.banner;
                _this.bannerTxt = bannerData.txt;
                _this.btnTxt = bannerData.btnTxt;
                _this.btnHref = bannerData.btnHref;
                _this.btnType = bannerData.btnType;
                _this.fontSize = bannerData.fontSize;
            }
            if(_this.bannerIndex === 3){
                let index = path.replace('/', '')
                bannerData = _this.data[index];
                _this.bannerTxt = bannerData.txt;
                _this.btnTxt = bannerData.btnTxt;
                _this.btnHref = bannerData.btnHref;
                _this.btnType = bannerData.btnType;
                _this.fontSize = bannerData.fontSize;
                setTimeout(function () {
                    _this.adTxt = false;
                },6000)
            }
            setTimeout(function () {
                _this.bannerState = true;
				// _this.bannerCss = "fadeIn";
            },200)
        }
    },
    mounted(){
        let _this = this;
        _this.selectBanner();
		if(_this.bannerIndex === 0) {
			_this.interval = setInterval(()=>{
				_this.bannerState = false;
				// _this.bannerCss = "fadeOut";
				setTimeout(function () {
					_this.bannerNum += 1;
					if(_this.bannerNum > 4){
						_this.bannerNum = 0;
					}
					_this.selectBanner();
				},500)
			},3000)
		}

        if(_this.bannerIndex === 1) {
            _this.$nextTick(() => {
                new Swiper('.swiper-container', {
                    speed: 5000,
                    autoplay: true,
                    autoplayDisableOnInteraction: false,
                    effect: "fade",
                    pagination: ".swiper-pagination",
                    paginationClickable: true,
                    on: {
                        slideChangeTransitionStart: function () {
                            let nextSlide = _this.slides.eq(_this.activeIndex);
                            nextSlide.addClass("centerBig");
                        },
                        slideChangeTransitionEnd: function () {
                            let prevSlide = _this.slides[_this.previousIndex];
                            prevSlide.className = "swiper-slide";
                        },
                    },
                })
            })
        }
    },
	unmounted(){
		if(this.interval){
			clearInterval(this.interval)
		}
	}
}
